import React from 'react';
import { Card } from 'react-bootstrap';
import './RecordCard.css';

/**
 * モバイル幅でテーブル1行を1枚のカードとして表示する汎用コンポーネント。
 * デスクトップは従来の <Table> を使い、モバイル(d-lg-none)でこれを並べる。
 *
 * props:
 *  - title:    主見出し(例: ゲスト名)
 *  - subtitle: 副見出し(例: 施設名・予約ID)。省略可
 *  - badges:   ステータスバッジ。<span className="badge bg-...">...</span> の配列(ReactNode[])。省略可
 *  - fields:   [{ label, value }] のkey-value行。value が falsy(0/空文字以外) の行は表示しない
 *  - actions:  ボタン群(ReactNode)。カード下部に縦積み・全幅で表示。省略可
 */
function RecordCard({ title, subtitle, badges, fields = [], actions }) {
  return (
    <Card className="record-card mb-2">
      <Card.Body>
        <div className="record-card__head">
          <div className="record-card__titles">
            {title != null && <div className="record-card__title">{title}</div>}
            {subtitle != null && subtitle !== '' && (
              <div className="record-card__subtitle">{subtitle}</div>
            )}
          </div>
          {badges && badges.length > 0 && (
            <div className="record-card__badges">{badges}</div>
          )}
        </div>

        {fields.length > 0 && (
          <dl className="record-card__fields">
            {fields
              .filter((f) => f && f.value !== undefined && f.value !== null && f.value !== '')
              .map((f, i) => (
                <div className="record-card__field" key={i}>
                  <dt>{f.label}</dt>
                  <dd>{f.value}</dd>
                </div>
              ))}
          </dl>
        )}

        {actions && <div className="record-card__actions">{actions}</div>}
      </Card.Body>
    </Card>
  );
}

export default RecordCard;
